// extracted by mini-css-extract-plugin
export default {"card":"ImportCustomersFromSegment_card__d1SC-","cardHeader":"ImportCustomersFromSegment_cardHeader__lOCDw","cardContent":"ImportCustomersFromSegment_cardContent__zZUI-"};